/** Stable keys for POST /api/hosting/visits — must match Hosting SPA and faircorp-api merge logic. */
export const VISIT_KEY_FAIRCORP_HUB = 'faircorp-hub';
